module.exports = __webpack_public_path__ + "media/images/features/draft/heading-mv-b603a5cd3ca4f6f8429095fc7c0137f7.svg";